import { computed, onMounted, ref } from 'vue'
import { useStore } from 'vuex'
import onTransitionendCallback from 'components/PageOverlay/methods/onTransitionendCallback'
import { getTeamParticipantEmails } from "foundation/js/teamParticipantUtils"

export default {
    name: "HoldetsDeltagere",
    props: {
        teamId: {
            type: String,
            required: false
        },
        addDeltagerFormUrl: {
            type: String,
            required: false
        },
        donationFormUrl: {
            type: String,
            required: false
        },
        lysposeFormUrl: {
            type: String,
            required: false
        }
    },
    setup(props) {
        const store = useStore()

        // Danish integer formatting: 10.000 (no decimals)
        const daInt = new Intl.NumberFormat('da-DK', { maximumFractionDigits: 0 })
        const formatInt = (value) => {
            const v = Number(value)
            return Number.isFinite(v) ? daInt.format(v) : ''
        }

        const teamId = computed(() => props.teamId ?? store.state.main.page_overlay_content_data.teamId)
        const addDeltagerFormUrl = computed(() => props.addDeltagerFormUrl ?? store.state.main.page_overlay_content_data.addDeltagerFormUrl)
        const donationFormUrl = computed(() => props.donationFormUrl ?? store.state.main.page_overlay_content_data.donationFormUrl)
        const lysposeFormUrl = computed(() => props.lysposeFormUrl ?? store.state.main.page_overlay_content_data.lysposeFormUrl)
        const participantList = computed(() => store.state.stafet.teamParticipantDetails)
        const participantEmails = computed(() => getTeamParticipantEmails(store.state.stafet.teamParticipantDetails))

        const getLabel = function (labelKey) {
            return store.getters['labels/getLabel']({
                labelCollection: 'HoldetsDeltagere',
                labelKey
            })
        }

        const getDonateToParticipantUrl = function (participant) {
            return `${donationFormUrl.value}&deltagerId=${participant.id}`
        }

        const getLysposeToParticipantUrl = function (participant) {
            return `${lysposeFormUrl.value}&deltagerId=${participant.id}`
        }

        const getParticipantFullName = function (participant) {
            return `${participant.firstName} ${participant.lastName ?? ''}`
        }

        const supportParticipantLabel = function (labelName, participant) {
            return `${getLabel(labelName)} ${participant.firstName}`
        }

        const openHoldkaptajnMailudsendelseOverlay = (e) => {
            store.dispatch('main/closePageOverlay')

            store.commit('main/set_page_overlay_content_data', { type: "Holdkaptajn" })
            store.dispatch('main/openPageOverlay', {
                overlayContent: "StafetMailEditorOverlay",
                returnTarget: e.currentTarget
            })
        }

        const toggleAccordion = function (e) {
            const isExpanded = !!(e.currentTarget.getAttribute('aria-expanded') === 'true')
            const accordionTarget = document.querySelector(`#${e.currentTarget.getAttribute('aria-controls')}`)
            const chevronTarget = e.currentTarget.querySelector('.kb-accordion__question__chevron')

            chevronTarget.classList[isExpanded ? 'remove' : 'add']('kb-accordion__question__chevron--open')
            accordionTarget.classList[isExpanded ? 'remove' : 'add']('kb-accordion__answer--open')
            e.currentTarget.setAttribute('aria-expanded', isExpanded ? 'false' : 'true')

            accordionTarget.querySelectorAll('a').forEach((a) => {
                if (isExpanded) {
                    a.setAttribute('tabindex', -1)
                } else {
                    a.removeAttribute('tabindex')
                }
            })
        }

        let first, last, close

        const tabTrap = function (e) {
            if (e.shiftKey && e.target.dataset.order === 'first') {
                e.preventDefault()
                close.focus()
            }

            if (!e.shiftKey && e.target.dataset.order === 'last') {
                e.preventDefault()
                close.focus()
            }

            if (!e.shiftKey && !e.target.dataset.order) {
                e.preventDefault()
                first.focus()
            }
        }

        onMounted(() => {
            first = document.querySelector('.kb-button[data-order="first"]')
            last = document.querySelector('.kb-button[data-order="last"]')
            close = document.querySelector('.kb-page-overlay__close')

            onTransitionendCallback(
                {
                    opening() {
                        first.focus()
                    }
                },
                { persistent: true }
            )

            store.dispatch('stafet/getTeamParticipantDetails', {
                teamId: teamId.value
            })
        })

        return {
            addDeltagerFormUrl,
            getDonateToParticipantUrl,
            getLysposeToParticipantUrl,
            tabTrap,
            participantList,
            toggleAccordion,
            supportParticipantLabel,
            getParticipantFullName,
            getLabel,
            participantEmails,
            openHoldkaptajnMailudsendelseOverlay,
            formatInt
        }
    }
}
